import React, { useEffect, useState } from "react";
import { maintenanceLogEndPoints } from "../../../../services/service-constants";
import { getMaintenanceScoreTableData, getGraphicalData } from "../../api";
import Pagination from "../../../../components/common/Pagination";

import "./index.scss";
import { LineGraphWithThreshold } from "../../../../components/common/LineGraph/LineGraphWiththreshold";
import Modal from "../../../../components/common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";

const TimeDrivenAction = () => {
  const [initialTableData, setInitialTableData] = useState(null);

  const [currentPage, setCurrentPage] = useState();

  const [isPageFirst, setIsPageFirst] = useState(false);

  const [isPageLast, setIsPageLast] = useState(false);

  const [selectedGraphData, setSelectedGraphData] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const vin_Number = useSelector((state) => state.mainReducer.vin_Number);

  const [pagenation, setPagenation] = useState({
    totalpages: 0,
    size: 0,
    currentPageNo: 0,
  });

  const onPageChanged = (val) => {
    const nextPage = val;
    getInitialData({
      page: nextPage,
    });
  };

  const getSelectedGraphData = (data) => {
    const returnData = {};
    const maintenanceLogsGraphs = data.maintenanceLogsGraphs;
    if (maintenanceLogsGraphs.length) {
      returnData["id"] = maintenanceLogsGraphs[0].graphName;
      returnData["xLabel"] = maintenanceLogsGraphs[0].xAxisName;
      returnData["yLabel"] = maintenanceLogsGraphs[0].yAxisName;
      const mainGraphData = maintenanceLogsGraphs.reduce((acc, el) => {
        acc.push({ x: el.xAxisData, y: el.yAxisData });
        return acc;
      }, []);
      returnData["dataSolid"] = mainGraphData;
    }
    const maintenanceLogsGraphsThresholds =
      data.maintenanceLogsGraphsThresholds;

    if (maintenanceLogsGraphsThresholds) {
      const extendedGraphData = [
        {
          x: maintenanceLogsGraphsThresholds.thresholdStart[0],
          y: maintenanceLogsGraphsThresholds.thresholdStart[1],
        },
        {
          x: maintenanceLogsGraphsThresholds.thresholdEnd[0],
          y: maintenanceLogsGraphsThresholds.thresholdEnd[1],
        },
      ];
      returnData["dataDotted"] = extendedGraphData;
      returnData["title"] = maintenanceLogsGraphsThresholds.graphLabel;
    }

    return returnData;
  };

  const getGraphData = async (item) => {
    const data = await getGraphicalData({
      url: `${maintenanceLogEndPoints.graph}`,
      statsDate: item.statsDate,
      graphName: item.graphName,
      vinNumber: vin_Number,
    });
    if (data) {
      const selectGraphData = getSelectedGraphData(data);
      setSelectedGraphData(selectGraphData);
      setShowModal(true);
    }
  };

  const getInitialData = async (payload) => {
    const { page, vinNumber } = payload;
    const data = await getMaintenanceScoreTableData({
      page: page,
      url: `${maintenanceLogEndPoints.time_driven_action}`,
      vinNumber: vinNumber,
    });
    if (data) {
      setInitialTableData(data?.content);
      setCurrentPage(data?.pageable?.pageNumber);
      setIsPageFirst(data?.first);
      setIsPageLast(data?.last);
      setPagenation({
        totalpages: data?.totalPages,
        size: data?.size,
        currentPageNo: data?.pageable?.pageNumber,
      });
    }
  };

  useEffect(() => {
    getInitialData({
      page: 0,
      vinNumber: vin_Number,
    });
  }, []);

  return (
    <>
      <table className="time-driven-action-table">
        <thead>
          <tr>
            <th>Prescheduled maintenance</th>
            <th>Metric</th>
            <th>Scheduled</th>
            <th>Completed</th>
            <th>Mileage</th>
            <th>Odometer</th>
            <th>Months in Service</th>
            <th>Violation</th>
            <th>Weighing factor</th>
          </tr>
        </thead>
        <tbody>
          {initialTableData?.length &&
            initialTableData.map((item) => (
              <tr key={item?.id}>
                <td>{item?.preScheduledMaintenance || "-"}</td>
                <td>{item?.metric || "-"}</td>
                <td>{item?.scheduled || "-"}</td>
                <td>{item?.completed || "-"}</td>
                <td>{item?.mileage || "-"}</td>
                <td>{item?.odometer || "-"}</td>
                <td>{item?.monthsInService || "-"}</td>
                <td>{item?.violation || "-"}</td>
                <td>
                  {item?.weighingFactor || "-"}{" "}
                  <span
                    className="view-details-from-table"
                    onClick={() => getGraphData(item)}
                  >
                    view details
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {pagenation.totalpages > 1 && (
        <div className="pagination-container">
          <Pagination
            pageCount={pagenation.totalpages}
            pageRange={pagenation.size}
            onPageChanged={onPageChanged}
          />
        </div>
      )}
      {showModal && (
        <div className="maintenance-log-graph-container">
          <Modal
            type={"large"}
            title={""}
            titlePosition={"center"}
            isError={false}
            handleClose={() => setShowModal(false)}
            wrapperClass="log-graph"
          >
            {selectedGraphData.id && (
              <LineGraphWithThreshold
                data={selectedGraphData}
              ></LineGraphWithThreshold>
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default TimeDrivenAction;
